import { render } from "./LayoutSidebar.vue?vue&type=template&id=672d0618&scoped=true"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js"

import "./LayoutSidebar.vue?vue&type=style&index=0&id=672d0618&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672d0618"]])

export default __exports__